import React, { Component } from 'react';
import { arrayOf, string } from 'prop-types';
import { orderBy } from 'lodash';
import StationChart from '../../../StationChart';

import { stationShape } from '../constants';
import styles from './styles.scss';

export class PlacementStationChart extends Component {
  static propTypes = {
    data: arrayOf(stationShape),
    yAxisTitle: string,
    selectedDataType: string
  }

  prepData() {
    const { data, selectedDataType } = this.props;
    const chartData = data.reduce((accum, currEntry) => {
      const { stationName, stationId } = currEntry;
      if (stationName && stationId) {
        accum.push({
          x: stationName,
          y: currEntry[selectedDataType]
        })
      }
      return accum;
    }, []);

    return orderBy(chartData, ['y'], 'desc');
  }

  render() {
    const { yAxisTitle, selectedDataType } = this.props;
    const chartData = this.prepData();

    return (
      <div data-test="placementStationChart" className={styles.placemenStationChart}>
        <StationChart
          data={chartData}
          yAxisTitle={yAxisTitle}
          isAvgCost={selectedDataType === 'avgAdCost'}
          isAdVisit={selectedDataType === 'adVisit'}
        />
      </div>
    );
  }
}
